module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAQCAYAAAA1Qw7OAAAAAXNSR0IArs4c6QAAABhJREFUKFNj/B+s+p8BC2AclUAPFXoECQBe6Cdxt5EWbQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tiao.png
// module id = OYu6
// module chunks = 128